module.exports = __webpack_public_path__ + "img/squatmarkercrimson.b97566ed.svg";